import React from 'react';
import {
  FaChartLine,
  FaHandsHelping,
  FaLaptopCode,
  FaLightbulb,
  FaUsers,
  FaRocket,
  FaHeart,
} from 'react-icons/fa';
import './Carreiras.css';

const Carreiras = () => {
  return (
    <div className="carreiras-container">
      {/* ===== TÍTULO PRINCIPAL ===== */}
      <div className="carreiras-header">
        <h1 className="carreiras-titulo">
          Construa sua carreira na <span className="destaque-amarelo">Carga Fácil</span>
        </h1>
        <p className="carreiras-subtitulo">
          Junte-se a uma equipa inovadora que está a revolucionar o transporte em Moçambique
        </p>
      </div>

      {/* ===== PORQUE TRABALHAR CONOSCO ===== */}
      <div className="beneficios-section">
        <div className="section-header">
          <h2>Por que fazer parte da Carga Fácil?</h2>
          <p>Oferecemos mais que um emprego – oferecemos uma carreira com propósito</p>
        </div>
        <div className="beneficios-grid">
          <div className="beneficio-card">
            <div className="icon-container">
              <FaChartLine className="beneficio-icon" />
            </div>
            <h3>Crescimento Profissional</h3>
            <p>Oportunidades contínuas de aprendizado e desenvolvimento na área de logística e tecnologia</p>
          </div>
          <div className="beneficio-card">
            <div className="icon-container">
              <FaHandsHelping className="beneficio-icon" />
            </div>
            <h3>Impacto Real</h3>
            <p>Seu trabalho contribuirá diretamente para melhorar a economia e infraestrutura do país</p>
          </div>
          <div className="beneficio-card">
            <div className="icon-container">
              <FaLaptopCode className="beneficio-icon" />
            </div>
            <h3>Tecnologia de Ponta</h3>
            <p>Trabalhe com as ferramentas mais modernas do mercado de logística digital</p>
          </div>
        </div>
      </div>

      {/* ===== CULTURA ===== */}
      <div className="cultura-section">
        <div className="section-header">
          <h2>Nossa Cultura</h2>
          <p>Valores que nos guiam e nos tornam únicos</p>
        </div>
        <div className="cultura-grid">
          <div className="cultura-card">
            <FaLightbulb className="cultura-icon" />
            <h3>Inovação</h3>
            <p>Buscamos constantemente novas maneiras de resolver problemas antigos da logística moçambicana.</p>
          </div>
          <div className="cultura-card">
            <FaUsers className="cultura-icon" />
            <h3>Colaboração</h3>
            <p>Trabalhamos em equipa, onde cada voz é ouvida e cada contribuição é valorizada.</p>
          </div>
          <div className="cultura-card">
            <FaHeart className="cultura-icon" />
            <h3>Responsabilidade</h3>
            <p>Assumimos compromissos sérios com nossos clientes, parceiros e colaboradores.</p>
          </div>
          <div className="cultura-card">
            <FaRocket className="cultura-icon" />
            <h3>Crescimento</h3>
            <p>Investimos no desenvolvimento contínuo de cada membro da nossa equipa.</p>
          </div>
        </div>
      </div>

      {/* ===== PROCESSO SELETIVO ===== */}
      <div className="processo-section">
        <div className="section-header">
          <h2>Nosso Processo Seletivo</h2>
          <p>Transparente, justo e focado no potencial</p>
        </div>
        <div className="processo-steps">
          <div className="processo-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Inscrição</h3>
              <p>Envie o seu currículo e informações através do nosso portal</p>
            </div>
          </div>
          <div className="processo-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Avaliação Inicial</h3>
              <p>A nossa equipa de RH analisa o seu perfil em até 5 dias úteis</p>
            </div>
          </div>
          <div className="processo-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Entrevista</h3>
              <p>Conversa com a nossa equipa para conhecer melhor as suas habilidades</p>
            </div>
          </div>
          <div className="processo-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Proposta</h3>
              <p>Se selecionado, receberá uma oferta competitiva e personalizada</p>
            </div>
          </div>
        </div>
      </div>

      {/* ===== CTA ===== */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>Pronto para embarcar nesta jornada?</h2>
          <p>Junte-se a nós e faça parte da revolução do transporte em Moçambique</p>
          <div className="cta-buttons">
            <button className="cta-button-primary">Ver Vagas Abertas</button>
            <a
              href="mailto:contacto@cargafacil.co.mz"
              className="cta-button-secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Enviar Currículo
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carreiras;